// How a flag reads in a document export — the one rule shared by the Excel
// workbook (estate-summary-excel-builder) and the PDF print
// (PDFPrintTransactions), so the two surfaces can never drift apart.
//
// A flag the case flag assessment WITHHELD exports as "<name> (withheld)".
// A live flag and a RESTORED flag (a reviewer's human verdict — undoing the
// stage's withhold) export UNMARKED: the human, not the model, is standing
// behind it, and the export must not imply a withheld flag is still an
// open AI concern. Counsel receiving a printed or spreadsheet copy cannot
// hover a chip, so the chip's honesty rule is applied here as text — it
// resolves through the SAME shared predicate the row and detail-dialog
// chips use (isFlagWithheld / flagChipColor, utils/flagWithheld.js):
// called, not restated, so no surface can drift from another.
//
// The `!flag_restored` half is defensive: the enriched read shadows a
// restored flag's suppressed twin server-side, so a SUPPRESSED row never
// carries the marker (see deriveIsWithheldFlag, api/transactions.js:88-95).
// The shared rule keeps the guard and the exports agree with the chip, not
// with the read contract.
//
// Row shape: works on the raw enriched row AND on
// mapTransactionToFilterableTransaction output — flag_status / flag_restored
// ride the spread unchanged (P1-5 row contract, pinned in
// api/transactions.test.js), and `flag.name` is the same value both
// surfaces already print. The two surfaces are pinned to this helper by
// components/ui/__tests__/flagExportAgreement.test.js.
import { isFlagWithheld } from './flagWithheld.js';

export const WITHHELD_FLAG_SUFFIX = ' (withheld)';

export const formatFlagForExport = (row) => {
  const name = row?.flag?.name;
  if (!name) return name; // no flag → the blank each surface already renders
  const withheld = isFlagWithheld(row);
  return withheld ? `${name}${WITHHELD_FLAG_SUFFIX}` : name;
};
